class r {
  getCookieByName(t) {
    const c = t + "=", i = document.cookie.split(";");
    for (const n of i) {
      const o = n.trimStart();
      if (o.indexOf(c) === 0) {
        const s = o.substring(
          c.length,
          o.length
        );
        return decodeURIComponent(s);
      }
    }
  }
}
function k(e) {
  return new r().getCookieByName(e);
}
export {
  k as getCookieByName
};
//# sourceMappingURL=index.js.map
